import { defineStore } from 'pinia';
import { getAreaPrices } from '@/services/modules/collection-area';

export const useAreaPriceSettingStore = defineStore('areaPriceSetting', {
  state() {
    return {
      areaPrices: []
    };
  },
  actions: {
    async getAreaPrices(type: String) {
      try {
        const response: any = await getAreaPrices(type);
        this.areaPrices = response;
        // response.map((ca: any) => {
        //   return {
        //     id: ca.id,
        //     name: ca.name,
        //     posCodes: ca.posCodes,
        //     disposalBurnableCost: ca.disposalBurnableCost,
        //     disposalRecyclableCost: ca.disposalRecyclableCost,
        //     disposalLargeSizeCost: ca.disposalLargeSizeCost,
        //     disposalFurnitureCost: ca.disposalFurnitureCost,
        //     transportBurnableCost: ca.transportBurnableCost,
        //     transportRecyclableCost: ca.transportRecyclableCost,
        //     transportLargeSizeCost: ca.transportLargeSizeCost,
        //     transportFurnitureCost: ca.transportFurnitureCost,
        //     type: ca.type,
        //     destination: ca.destination
        //   };
        // });
      } catch (e) {
        console.log(e);
      }
    }
  }
});
